var B = Object.defineProperty, _ = Object.defineProperties;
var U = Object.getOwnPropertyDescriptors;
var v = Object.getOwnPropertySymbols;
var $ = Object.prototype.hasOwnProperty, O = Object.prototype.propertyIsEnumerable;
var S = (n, o, e) => o in n ? B(n, o, { enumerable: !0, configurable: !0, writable: !0, value: e }) : n[o] = e, f = (n, o) => {
  for (var e in o || (o = {}))
    $.call(o, e) && S(n, e, o[e]);
  if (v)
    for (var e of v(o))
      O.call(o, e) && S(n, e, o[e]);
  return n;
}, A = (n, o) => _(n, U(o));
var x = (n, o, e) => new Promise((r, a) => {
  var t = (s) => {
    try {
      i(e.next(s));
    } catch (c) {
      a(c);
    }
  }, p = (s) => {
    try {
      i(e.throw(s));
    } catch (c) {
      a(c);
    }
  }, i = (s) => s.done ? r(s.value) : Promise.resolve(s.value).then(t, p);
  i((e = e.apply(n, o)).next());
});
import { queryURLParams as g, getTGShareUrl as V } from "./url/index.js";
import { MORE as L, COPY as N, TELEGRAM as R, INSTAGRAM as M, WHATSAPP as W } from "./constant/index.js";
import j from "ua-parser-js";
function nn() {
  return !!window.ProApp;
}
function C() {
  return !!window.TaurusApp || !!window.ProApp || m();
}
function m() {
  return !!window.SmartEarnApp;
}
const en = (n = 600) => window.innerWidth <= n;
function on() {
  return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
}
function rn() {
  var n;
  return !(!m() || !((n = window.SmartEarnApp) != null && n.hasAdvertise)) && window.SmartEarnApp.hasAdvertise();
}
function an(n = "") {
  var o, e;
  return m() && ((o = window.SmartEarnApp) != null && o.showAdvertise) ? ((e = T()) == null ? void 0 : e.appVersion) < 205 ? window.SmartEarnApp.showAdvertise() : window.SmartEarnApp.showAdvertise(n) : !1;
}
function tn() {
  var n, o, e;
  window.ProApp ? (n = window.ProApp) == null || n.finish() : typeof ((o = window.TaurusApp) == null ? void 0 : o.back) != "function" ? window.SmartEarnApp && ((e = window.SmartEarnApp) == null || e.finishCurrentActivity()) : window.TaurusApp.back();
}
function pn(n) {
  var o, e, r;
  window.ProApp ? (o = window.ProApp) == null || o.toast(n) : window.TaurusApp ? (e = window.TaurusApp) == null || e.toast(n) : window.SmartEarnApp && ((r = window.SmartEarnApp) == null || r.toast(n));
}
function sn() {
  var n, o, e;
  window.ProApp ? (n = window.ProApp) == null || n.keyboardUp() : window.TaurusApp ? (o = window.TaurusApp) == null || o.pullUpKeyboard() : window.SmartEarnApp && ((e = window.SmartEarnApp) == null || e.showSoftInput());
}
function un(n) {
  var o, e, r;
  window.ProApp ? (o = window.ProApp) == null || o.copyText2Clipboard(n) : window.TaurusApp ? (e = window.TaurusApp) == null || e.copyText2Clipboard(n) : window.SmartEarnApp && ((r = window.SmartEarnApp) == null || r.copyToClipboard(n));
}
function wn(n) {
  var o;
  window.SmartEarnApp && ((o = window.SmartEarnApp) == null || o.copyClipboardAndToast(n));
}
function cn() {
  var n, o;
  window.ProApp ? (n = window.ProApp) == null || n.setStatusBarTransparent() : window.TaurusApp && ((o = window.TaurusApp) == null || o.setStatusBarTransparent());
}
function dn() {
  var n, o, e;
  return window.ProApp ? (n = window.ProApp) == null ? void 0 : n.getStatusBarHeight() : window.TaurusApp ? (o = window.TaurusApp) == null ? void 0 : o.getStatusBarHeight() : window.SmartEarnApp ? (e = window.SmartEarnApp) == null ? void 0 : e.getStatusBarHeight() : void 0;
}
function ln() {
  var n, o, e;
  if (window.ProApp) (n = window.ProApp) == null || n.transparentStatusBar();
  else {
    if (!window.TaurusApp) return window.SmartEarnApp ? (o = window.SmartEarnApp) == null ? void 0 : o.transparentStatusBar() : void 0;
    (e = window.TaurusApp) == null || e.transparentStatusBar();
  }
}
function mn(n) {
  var o, e, r;
  window.ProApp ? (o = window.ProApp) == null || o.setStatusBarColor(n) : window.TaurusApp ? (e = window.TaurusApp) == null || e.setStatusBarColor(n) : window.SmartEarnApp && ((r = window.SmartEarnApp) == null || r.setStatusBarColor(n));
}
function fn(n) {
  var o, e;
  window.ProApp ? (o = window.ProApp) == null || o.articleEdit(Number(n)) : window.TaurusApp && ((e = window.TaurusApp) == null || e.articleEdit(Number(n)));
}
function An(n) {
  var o, e;
  window.ProApp ? (o = window.ProApp) == null || o.articleDelete(Number(n)) : window.TaurusApp && ((e = window.TaurusApp) == null || e.articleDelete(Number(n)));
}
function gn(n, o) {
  var e, r, a;
  window.ProApp ? (e = window.ProApp) == null || e.openBrowser(n) : window.TaurusApp && (((r = T()) == null ? void 0 : r.appVersion) >= 220300402 ? (a = window.TaurusApp) == null || a.openBrowser(n) : o && o());
}
function hn() {
  var n, o;
  return window.ProApp ? (n = window.ProApp) == null ? void 0 : n.getAuthCode() : window.TaurusApp ? (o = window.TaurusApp) == null ? void 0 : o.getAuthCode() : void 0;
}
function Tn() {
  var n, o;
  window.ProApp ? (n = window.ProApp) == null || n.shareDefault() : window.TaurusApp && ((o = window.TaurusApp) == null || o.shareTaurus());
}
function F(n, o) {
  var e, r;
  window.ProApp ? (e = window.ProApp) == null || e.setClipboardText(n, o) : window.TaurusApp && ((r = window.TaurusApp) == null || r.setClipboardText(n, o));
}
function yn(n, o, e = "uploadSuccess") {
  var r, a;
  window.ProApp ? (r = window.ProApp) == null || r.upload(n, o, e) : window.TaurusApp && ((a = window.TaurusApp) == null || a.upload(n, o, e));
}
function bn(n, o) {
  var e, r;
  window.ProApp ? (e = window.ProApp) == null || e.previewFile(n, o) : window.TaurusApp && ((r = window.TaurusApp) == null || r.preview(n, o));
}
function vn(n, o) {
  let e = "";
  l("Telegram", n) ? e = `tg://resolve?domain=${o}` : l("Whatsapp", n) && (e = `whatsapp://send?phone=${o}`), window.open(e, "_blank");
}
function Sn(n, o, e) {
  let r = "";
  l("WhatsApp", n) ? r = `https://api.whatsapp.com/send?text=${encodeURIComponent(o)}&image=${encodeURIComponent(e)}` : l("Telegram", n) ? r = `tg://resolve?text=${encodeURIComponent(o)}` : l("Facebook", n) && (r = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(o)}`), window.open(r, "_blank");
}
function T() {
  var a, t, p;
  let n = "", o = !1;
  if (window.ProApp) n = (a = window.ProApp) == null ? void 0 : a.getDeviceInfo(), o = !0;
  else if (window.TaurusApp) n = (t = window.TaurusApp) == null ? void 0 : t.getDevicesInfo();
  else {
    if (!window.SmartEarnApp) return {};
    n = (p = window.SmartEarnApp) == null ? void 0 : p.getAppInfo();
  }
  const e = n ? JSON.parse(n) : {}, r = { gaid: e == null ? void 0 : e.s_gaid, aid: e == null ? void 0 : e.s_android_id, channel: e == null ? void 0 : e.s_channel, pkg: e == null ? void 0 : e.s_pkg, shareCode: e == null ? void 0 : e.shareCode, code: (e == null ? void 0 : e.code) || g("code"), token: (e == null ? void 0 : e.token) || g("token"), lang: e == null ? void 0 : e.language, appType: e == null ? void 0 : e.appType };
  return o ? A(f({}, r), { appVersion: e == null ? void 0 : e.appVersion, signVersion: e == null ? void 0 : e.signVersion, level: e == null ? void 0 : e.level, referrer: e == null ? void 0 : e.referrer, attribution: e == null ? void 0 : e.attribution, isNewPkg: o }) : m() ? A(f({}, r), { appVersion: e == null ? void 0 : e.appVersion, signVersion: e == null ? void 0 : e.signVersion, pkgType: e == null ? void 0 : e.pkgType }) : A(f({}, r), { appVersion: (e == null ? void 0 : e.appVersion) || (e == null ? void 0 : e.s_ver), isNewPkg: o });
}
function w(n, o, e, r, a, t) {
  var p, i, s;
  window.ProApp && ((p = window.ProApp) == null || p.share(n, o, e, r, a, t)), window.TaurusApp && ((i = window.TaurusApp) == null || i.share(n, o, e, r, a, t)), window.SmartEarnApp && ((s = window.SmartEarnApp) == null || s.share(n, o, e, r, a, t));
}
function xn(n, o, e) {
  w("com.whatsapp", "", n, "", o, e);
}
function Pn(n, o, e) {
  w("com.facebook.katana", "", n, "", o, e);
}
function Cn(n, o, e) {
  w("com.instagram.android", "com.instagram.share.handleractivity.ShareHandlerActivity", n, "", o, e);
}
function En(n, o, e) {
  w("org.telegram.messenger", "org.telegram.ui.LaunchActivity", n, "", o, e);
}
function kn(n, o) {
  w("", "", "", "", n, o);
}
function H() {
  const n = navigator.userAgent || window.opera;
  return n.indexOf("FB_") > -1 || n.indexOf("FBAV") > -1;
}
function E() {
  var n;
  return !!((n = window.Telegram) != null && n.WebView);
}
function D() {
  var n, o, e;
  return !!((e = (o = (n = window == null ? void 0 : window.Telegram) == null ? void 0 : n.WebApp) == null ? void 0 : o.initDataUnsafe) != null && e.user);
}
function In() {
  const { browser: n, device: o, engine: e, os: r } = j(window.navigator.userAgent);
  return { browser: n.name, os: r.name, deviceType: o.type, deviceModel: o.model, browserEngine: e.name };
}
function q(n, o, e) {
  if (!n) return;
  const r = n.toLocaleLowerCase(), a = { whatsapp: `whatsapp://send?text=${encodeURIComponent(o)}`, facebook: `fb://u=${encodeURIComponent(o)}`, instagram: "intent://instagram.com#Intent;scheme=https;package=com.instagram.android;end", telegram: `tg://msg?text=${encodeURIComponent(o)}` };
  ["instagram", "facebook"].includes(r) && h(o, e), window.location.href = a[r];
}
function Bn(n, o, e) {
  let r = "taurus://online.tasyee";
  n && (r = `taurus://online.tasyee?p=${encodeURIComponent(JSON.stringify(n))}`), function(a, t, p) {
    let i = document.createElement("iframe");
    i.style.display = "none", i.src = a, document.body.appendChild(i);
    let s = !1;
    const c = setTimeout(() => {
      s || (p && p(), i.parentNode === document.body && document.body.removeChild(i), window.clearTimeout(c));
    }, 2e3);
    i.onload = function() {
      var u, d;
      s = !0, document.body.removeChild(i), t && t(), D() ? (d = (u = window == null ? void 0 : window.Telegram) == null ? void 0 : u.WebApp) == null || d.openLink(a) : location.href = a;
    };
  }(r, () => {
    console.log("App is installed"), o && o();
  }, () => {
    console.log("App is not installed"), e && e();
  });
}
function _n(n = 10, o = 1800) {
  let e = 0, r = null;
  const a = () => {
    if (e++, e >= n) return sessionStorage.setItem("debug", "1"), void location.reload();
    clearTimeout(r), r = setTimeout(() => {
      e = 0;
    }, o);
  };
  return document.addEventListener("click", a), () => {
    document.removeEventListener("click", a);
  };
}
function Un() {
  return H() ? "fb" : C() ? "taurus" : E() ? "tg" : m() ? "smart_earn" : "other";
}
function $n(n, o = 5e3) {
  if ("requestIdleCallback" in window) requestIdleCallback(n, { timeout: o });
  else {
    const e = setTimeout(n, o);
    window.clearTimeout(e);
  }
}
function On({ url: n, content: o, pic: e, templateInfo: r, lang: a, mediaName: t, clicpCb: p = null } = {}) {
  var y, b;
  const { shareContentEn: i, shareContentHi: s, sharePic: c, shareUrl: u } = r || {};
  if (n = n || u, o = o || a == "hi" && s || i, e = e || c, C() && t) {
    switch (F(u, o), t) {
      case W:
        w("com.whatsapp", "", e, "", u, o);
        break;
      case M:
        w("com.instagram.android", "com.instagram.share.handleractivity.ShareHandlerActivity", e, "", u, o);
        break;
      case R:
        w("org.telegram.messenger", "org.telegram.ui.LaunchActivity", e, "", u, o);
        break;
      case N:
        break;
      case L:
        w("", "", "", "", u, o);
    }
    return;
  }
  const d = `${o}
  ${n}`;
  if (E()) {
    const I = V(o, n);
    return h(d, () => p == null ? void 0 : p()), void ((b = (y = window == null ? void 0 : window.Telegram) == null ? void 0 : y.WebApp) == null ? void 0 : b.openTelegramLink(I));
  }
  h(d), q(t, d, p);
}
function Vn() {
  const n = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  return n ? n.effectiveType : "unknown";
}
function l(n, o) {
  return !(!n || !o) && n.toLowerCase() === o.toLowerCase();
}
function Ln(n, o = "") {
  return (n == null ? void 0 : n.indexOf("file:///android_asset/default_avatars/ic_default_avatar")) != -1 ? G(n, o) : n;
}
function G(n, o = "") {
  const e = /* @__PURE__ */ new Map();
  let r = `${o}/avatar/default-avatar`;
  for (let a = 1; a <= 5; a++) e.set(`file:///android_asset/default_avatars/ic_default_avatar_${a}.png`, `${r}${a}.webp`);
  return e.get(n);
}
function Nn(n = "en") {
  var t, p, i;
  const { deviceLang: o } = ((t = T()) == null ? void 0 : t.lang) || {}, e = ((p = window.localStorage) == null ? void 0 : p.getItem("language")) || ((i = window.navigator.language) == null ? void 0 : i.toLowerCase()), r = g("language");
  let a = n;
  return r ? a = r : e.includes("hi") && (a = "hi"), a = o || a, window.localStorage.setItem("language", a), a;
}
function Rn() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (n) => (n === "x" ? 16 * Math.random() | 0 : 8).toString(16));
}
function Mn(n, o) {
  let e = !1;
  return (...r) => {
    if (e) return;
    n.apply(this, r), e = !0;
    const a = setTimeout(() => {
      e = !1, clearTimeout(a);
    }, o);
  };
}
function Wn(n, o = 2e3, e = !0) {
  let r, a, t = !0;
  function p(...i) {
    return r && clearTimeout(r), e ? (t && (a = n.apply(this, i)), t = !1, r = setTimeout(() => {
      t = !0;
    }, o)) : r = setTimeout(() => {
      n.apply(this, i);
    }, o), a;
  }
  return p.cancel = function() {
    clearTimeout(r), r = null, t = !0;
  }, p;
}
function h(n, o) {
  return x(this, null, function* () {
    if (navigator.clipboard) {
      try {
        yield navigator.clipboard.writeText(n), o && o();
      } catch (r) {
        console.log("error", r);
      }
      return;
    }
    const e = document.createElement("textarea");
    e.value = n, e.style.position = "fixed", e.style.opacity = "0", document.body.appendChild(e), e.focus(), e.select();
    try {
      document.execCommand("copy"), o && o();
    } catch (r) {
      console.log("error", r);
    }
    document.body.removeChild(e);
  });
}
function jn(n) {
  n.forEach((o) => {
    o.timer != null && (o.type == "interval" ? clearInterval(o.timer) : clearTimeout(o.timer), o.timer = null);
  });
}
function Fn(n, o, e) {
  let r = 0;
  const a = () => {
    if (r >= n.length) return;
    const { cb: t, time: p } = n[r];
    o && o();
    const i = setTimeout(() => {
      e && e(), clearTimeout(i), t(), r++, a();
    }, p || 500);
  };
  a();
}
function Hn(n, o) {
  const e = performance.now();
  requestAnimationFrame(function r() {
    performance.now() - e >= o ? n() : requestAnimationFrame(r);
  });
}
function J(n) {
  return !n || Object.keys(n).length === 0;
}
function Q(n) {
  return n == null || typeof n == "string" && (n.trim() === "" || n === "null" || n === "undefined");
}
function Dn(n, o) {
  return Q(n) ? o : n;
}
function k(n) {
  return !(n === null || typeof n != "object" || n.constructor !== Object || n instanceof Array || n instanceof Function);
}
function z(n) {
  return Array.isArray(n) && n.length != 0 && !(n instanceof Function);
}
function qn(n) {
  return !J(n) && (k(n) || z(n));
}
function Gn(n) {
  if (!n) return null;
  if (!k(n)) return n;
  let o = {};
  for (let e in n) Object.prototype.hasOwnProperty.call(n, e) && n[e] !== null && n[e] !== void 0 && n[e] !== "" && (o[e] = n[e]);
  return Object.keys(o).length === 0 ? null : o;
}
function P(n) {
  const o = new Uint8Array(n);
  return window.crypto.getRandomValues(o), Array.from(o, (e) => e.toString(16).padStart(2, "0")).join("");
}
function Jn() {
  return `00-${P(16)}-${P(8)}-01`;
}
function Qn(n, o) {
  if (!n || typeof n != "object" || !Array.isArray(o)) throw new Error("Invalid arguments: Expected an object and an array of keys.");
  return o.forEach((e) => {
    Object.prototype.hasOwnProperty.call(n, e) && delete n[e];
  }), n;
}
function zn(n) {
  return n.replace(/-(\w)/g, (o, e) => e.toUpperCase());
}
function Kn(n) {
  return n.replace(/^\w/, (o) => o.toUpperCase());
}
function Yn(n, o) {
  const e = n.split(".").map(Number), r = o.split(".").map(Number), a = Math.max(e.length, r.length);
  for (let t = 0; t < a; t++) {
    const p = e[t] || 0, i = r[t] || 0;
    if (p > i) return 1;
    if (p < i) return -1;
  }
  return 0;
}
export {
  Pn as $,
  m as A,
  en as B,
  on as C,
  rn as D,
  an as E,
  tn as F,
  pn as G,
  sn as H,
  un as I,
  wn as J,
  cn as K,
  dn as L,
  ln as M,
  mn as N,
  fn as O,
  An as P,
  gn as Q,
  hn as R,
  Tn as S,
  F as T,
  yn as U,
  bn as V,
  vn as W,
  Sn as X,
  T as Y,
  w as Z,
  xn as _,
  G as a,
  Cn as a0,
  En as a1,
  kn as a2,
  H as a3,
  E as a4,
  D as a5,
  In as a6,
  q as a7,
  Bn as a8,
  _n as a9,
  Un as aa,
  $n as ab,
  On as ac,
  Vn as ad,
  Nn as b,
  Rn as c,
  Wn as d,
  h as e,
  jn as f,
  Ln as g,
  Hn as h,
  J as i,
  Q as j,
  Dn as k,
  k as l,
  z as m,
  qn as n,
  Gn as o,
  P as p,
  Jn as q,
  Fn as r,
  l as s,
  Mn as t,
  Qn as u,
  zn as v,
  Kn as w,
  Yn as x,
  nn as y,
  C as z
};
